import { render, staticRenderFns } from "./InvoiceModifier.vue?vue&type=template&id=b5eb04e8&scoped=true"
import script from "./InvoiceModifier.vue?vue&type=script&lang=js"
export * from "./InvoiceModifier.vue?vue&type=script&lang=js"
import style0 from "./InvoiceModifier.vue?vue&type=style&index=0&id=b5eb04e8&prod&lang=scss"
import style1 from "./InvoiceModifier.vue?vue&type=style&index=1&id=b5eb04e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5eb04e8",
  null
  
)

export default component.exports